import io from "socket.io-client";
import { getUsertoken } from "@/utils/auth.js";

// Configuración de opciones para evitar problemas de conexión
const options = {
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  forceNew: true,
  transports: ['websocket', 'polling']
};

// Usar la URL de socket del .env
const socket = io(process.env.VUE_APP_SOCKET_ENVIRONMENT, options);

// Bind the user to their tenant room so the server can scope emits.
// localStorage["token"] is the decoded user object (not a raw JWT).
// The backend will require a verified JWT here to derive user + tenant
// instead of trusting client-supplied fields (card #391) — `token` must be
// the SAME raw JWT string sent as `Authorization: Bearer <token>` in HTTP
// calls, parsed with the same helper the http layer uses (getUsertoken()).
export function bindUserToSocket() {
  try {
    const userData = JSON.parse(localStorage.getItem('token') || '{}');
    const token = getUsertoken();

    if (!token) {
      console.warn('conexionSocket: bindUser omitido (sin token)');
      return;
    }
    if (!userData || !userData.id_usuario) {
      console.warn('conexionSocket: bindUser omitido (sin datos de usuario)');
      return;
    }

    if (!socket.connected) {
      // logout() llama a socket.disconnect(), que desactiva la reconexión
      // automática. Si el login ocurre en el mismo tab (SPA, sin reload),
      // nada vuelve a llamar connect() y el bind queda muerto (card #391).
      // Forzamos la reconexión acá; el handler 'connect' hace el bind
      // cuando el socket quede arriba, evitando un emit duplicado.
      socket.connect();
      return;
    }

    socket.emit('bindUser', {
      id_usuario: userData.id_usuario,
      nombre: userData.nombre,
      apellido: userData.apellido,
      id_rol: userData.id_rol,
      rol: userData.rol,
      telefono: userData.telefono,
      empresa_cliente: userData.empresa_cliente,
      token,
    });
  } catch (e) {
    console.error('conexionSocket: error al emitir bindUser', e);
  }
}

// Manejadores de eventos para depuración
socket.on('connect', () => {
  console.log('Socket conectado correctamente');
  bindUserToSocket();
});

socket.on('connect_error', (error) => {
  // console.error('Error de conexión socket:', error);
});

// Diagnóstico de estabilidad: nos interesa saber si el socket se cae mientras un
// proceso largo (ej: generación de reporte async) está en curso, porque un emit
// que ocurre durante la desconexión se pierde en vivo (socket.io no lo reintenta).
socket.on('disconnect', (reason) => {
  console.warn('Socket desconectado:', reason);
});
socket.io.on('reconnect', (attempt) => {
  console.log(`Socket reconectado (intento ${attempt})`);
});

export default socket;